function parsePreis(text) {
  var cleaned = text.replace(/[^0-9.,]/g, '');
  var lastComma = cleaned.lastIndexOf(',');
  var lastDot = cleaned.lastIndexOf('.');
  var lastSep = Math.max(lastComma, lastDot);
  if (lastSep === -1) return parseFloat(cleaned);
  var ganzzahl = cleaned.slice(0, lastSep).replace(/[.,]/g, '');
  var dezimal = cleaned.slice(lastSep + 1);
  return parseFloat(ganzzahl + '.' + dezimal);
}

function preiseProKgAktualisieren() {
  var weightGrams = window.produktGewichtGramm;
  if (!weightGrams) return;
  var weightKg = weightGrams / 1000;

  document.querySelectorAll('.sls-price-below').forEach(function (priceBelow, index) {
    var priceBox = priceBelow.closest('.sls-price');
    var moneySpan = priceBox ? priceBox.querySelector('.money') : null;
    if (!moneySpan) return;

    var preisWert = parsePreis(moneySpan.textContent);
    if (isNaN(preisWert)) return;

    var row = priceBelow.closest('.sls-selling-plan-group-first-line');
    var planLabel = row ? row.querySelector('.sls-selling-plan-group-name') : null;
    if (!planLabel) return;

    var pricePerKg = preisWert / weightKg;
    var formatted = pricePerKg.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €/kg';

    var targetId = 'preis-pro-kg-' + index;
    var target = document.getElementById(targetId);
    if (!target) {
      target = document.createElement('div');
      target.id = targetId;
      target.className = 'preis-pro-kg-hinweis';
      planLabel.insertAdjacentElement('afterend', target);
    }
    target.textContent = '(entspricht ' + formatted + ')';
  });
}

document.addEventListener('change', function (e) {
  if (e.target.name === 'id' && window.produktVariantenGewichte) {
    var neuesGewicht = window.produktVariantenGewichte[e.target.value];
    if (neuesGewicht) {
      window.produktGewichtGramm = neuesGewicht;
    }
  }
});
document.addEventListener('sealsubs:price_update', preiseProKgAktualisieren);
document.addEventListener('sealsubs:selling_plan_changed', preiseProKgAktualisieren);
document.addEventListener('DOMContentLoaded', preiseProKgAktualisieren);


function grundpreiseImWarenkorbKorrigieren() {
  fetch('/cart.js')
    .then(function (res) { return res.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-item').forEach(function (row) {
        var indexInput = row.querySelector('[data-index]');
        if (!indexInput) return;
        var index = parseInt(indexInput.getAttribute('data-index'), 10);

        var item = cart.items[index - 1];
        if (!item || !item.unit_price) return;

        var formatted = (item.unit_price / 100).toLocaleString('de-DE', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        });

        var unitPriceEl = row.querySelector('.unit-price.caption');
        if (!unitPriceEl) return;

        unitPriceEl.innerHTML =
          '<span class="visually-hidden">Grundpreis</span>' +
          '€' + formatted +
          '<span aria-hidden="true">/</span>' +
          '<span class="visually-hidden">&nbsp;pro&nbsp;</span>kg';
      });
    });
}

document.addEventListener('DOMContentLoaded', grundpreiseImWarenkorbKorrigieren);

var grundpreisDebounce;
new MutationObserver(function () {
  clearTimeout(grundpreisDebounce);
  grundpreisDebounce = setTimeout(grundpreiseImWarenkorbKorrigieren, 200);
}).observe(document.body, { childList: true, subtree: true });